// extracted by mini-css-extract-plugin
module.exports = {"HorizontalLine":"HorizontalLine-module__HorizontalLine___3I7hx","horizontalLine":"HorizontalLine-module__HorizontalLine___3I7hx"};